import { render, staticRenderFns } from "./CreatorPaidShareView.vue?vue&type=template&id=ac31f28e&"
import script from "./CreatorPaidShareView.vue?vue&type=script&lang=js&"
export * from "./CreatorPaidShareView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports